module.exports = __webpack_public_path__ + "static/img/exciting-main-img02.deae31a8.svg";